<p-toast></p-toast>
<p-accordion #currency [multiple]="true">
  <p-accordionTab [selected]="true">
    <ng-template pTemplate="header">
      <h5>График валют</h5>
    </ng-template>
    <app-home-chart-currency-rates [today]="today" appStopAccordionHomeEnd></app-home-chart-currency-rates>
  </p-accordionTab>
  <p-accordionTab [selected]="true">
    <ng-template pTemplate="header">
      <h5>Актуальные курсы валют</h5>
    </ng-template>
    <app-list-currency-rates appStopAccordionHomeEnd></app-list-currency-rates>
  </p-accordionTab>
  <p-accordionTab [selected]="false">
    <ng-template pTemplate="header">
      <h5>Импорт курсов валют</h5>
    </ng-template>
    <app-update-currency-by-external-api appStopAccordionHomeEnd></app-update-currency-by-external-api>
  </p-accordionTab>
  <p-accordionTab [selected]="false">
    <ng-template pTemplate="header">
      <h5>Курсы валют</h5>
    </ng-template>
    <p-toolbar styleClass="" appStopAccordionHomeEnd>
      <ng-template pTemplate="left">
        <p-button label="Добавить" icon="pi pi-plus" styleClass="p-button-success mr-2" (onClick)="onNewCurrencyRate($event)"
                  [disabled]="editMode" pTooltip="Добавить курс выбранной валюты" tooltipPosition="top"></p-button>
        <p-button label="Delete" icon="pi pi-trash" styleClass="p-button-danger" (onClick)="onDeleteCurrencyRow($event)"
                  [disabled]="editMode || !isThereSelectedRow" pTooltip="Удалить выбранный курс" tooltipPosition="top"></p-button>
      </ng-template>

      <ng-template pTemplate="right">
        <!--        <p-fileUpload mode="basic" accept="image/*" [maxFileSize]="1000000" label="Import" chooseLabel="Import" class="mr-2 p-d-inline-block"></p-fileUpload>-->
        <p-button icon="pi pi-undo" label="Сбросить фильтр" styleClass="p-button-success mr-2" (onClick)="clearOrResetTableFilter($event)"
                  pTooltip="Сбросить фильтр и вернуться в начало" tooltipPosition="top"></p-button>
        <p-button icon="pi pi-refresh" label="Обновить таблицу" styleClass="p-button-success mr-2" (onClick)="refreshTable($event)"
                  pTooltip="Обновить данные в таблице" tooltipPosition="top"></p-button>
        <p-button label="Export" icon="pi pi-upload" styleClass="p-button-info mr-2" (onClick)="onExportData()"></p-button>
      </ng-template>
    </p-toolbar>
    <p-table #CRT1
             appStopAccordionHomeEnd
             [value]="currencyRatesList"
             [lazy]="true"
             (onLazyLoad)="loadCurrencyRates($event)"
             [paginator]="true"
             [rows]="rows"
             [totalRecords]="totalRecords"
             [loading]="loading"
             [showCurrentPageReport]="true"
             [rowsPerPageOptions]="[10,20,50,100]"
             currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} записей"
             selectionMode="single"
             [(selection)]="selectedCurrencyRatesItem"
             dataKey="CRID"
             editMode="row"
             [rowHover]="true"
             (onRowSelect)="onRowSelect($event)"
             (onRowUnselect)="onRowUnselect($event)"
             styleClass="p-datatable-gridlines p-datatable-striped"
             stateStorage="local"
             stateKey="currencyRatesList-state"
             (onStateSave)="onStateSave($event)"
             (onStateRestore)="onStateRestore($event)"
             [resizableColumns]="true"
             columnResizeMode="fit"
             (onFilter)="filterProdTable($event)"
             filterDelay="500"
             sortField="CRDATE"
             sortOrder="-1"
             (onSort)="onSortCurrRates($event)">
      <ng-template pTemplate="caption">
        <div class="flex flex-wrap align-items-center">
          <h3 class="ml-0 mr-auto do-not-wrap-text">Курсы валют</h3>
          <!--<p-button icon="pi pi-undo" label="Сбросить фильтр" class="mr-2" (onClick)="clearOrResetTableFilter($event)"
      pTooltip="Сбросить фильтр и вернуться в начало" tooltipPosition="top"></p-button>-->
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th style="width: 6rem">...</th>
          <th pSortableColumn="CURCODE" pResizableColumn style="width: 20%">Код валюты <p-sortIcon field="CURCODE"></p-sortIcon></th>
          <th pSortableColumn="CURNAME" pResizableColumn style="width: auto">Название <p-sortIcon field="CURNAME"></p-sortIcon></th>
          <th pSortableColumn="CRDATE" pResizableColumn style="width: 15%">Дата <p-sortIcon field="CRDATE"></p-sortIcon></th>
          <th pSortableColumn="CRVALUE" pResizableColumn style="width: 15%">Курс <p-sortIcon field="CRVALUE"></p-sortIcon></th>
        </tr>
        <tr>
          <th>...</th>
          <th style="overflow: visible !important">
            <p-multiSelect [options]="currencyList" placeholder="Все валюты" [(ngModel)]="currencyListDS"
                           [maxSelectedLabels]="2" [selectedItemsLabel]="'{0} валюты выбрано'"
                           [showToggleAll]="true" [selectAll]="selectAllCurrencies"
                           (onChange)="onCurrListChange($event)" (onSelectAllChange)="onAllCurrListChange($event)" styleClass="p-column-filter p-dropdown-filter-style" optionLabel="CURCODE">
            </p-multiSelect>
          </th>
          <th>
            <input pInputText type="text" placeholder="Поиск" [(ngModel)]="currNameFilter" class="p-column-filter" (input)="CRT1.filter($event.target.value, 'CURNAME', 'in')">
          </th>
          <th>
            <input pInputText type="date" placeholder="Поиск" [(ngModel)]="currDateFilter" class="p-column-filter" (input)="CRT1.filter($event.target.value, 'CRDATE', 'lt')">
          </th>
          <th>
            <input pInputText type="number" placeholder="Поиск" [(ngModel)]="currRateFilter" class="p-column-filter" (input)="CRT1.filter($event.target.value, 'CRVALUE', 'gtOrZero')">
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-currencyrates let-editing="editing" let-ri="rowIndex">
        <tr [pSelectableRow]="currencyrates" [pEditableRow]="currencyrates">
          <td>
            <button *ngIf="!editing && !editMode" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onPpRowEditInit(currencyrates)" class="p-button-rounded p-button-text"></button>
            <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onPpRowEditSave(currencyrates)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
            <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onPpRowEditCancel(currencyrates, ri)" class="p-button-rounded p-button-text p-button-danger"></button>
          </td>
          <td style="overflow: visible !important" [pTooltip]="'CURID: ' + currencyrates.CURID" tooltipPosition="top">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-dropdown [options]="currencyEditorList" [(ngModel)]="currencyrates.CURID" optionLabel="CURCODE" optionValue="CURID" [style]="{'width':'100%'}"></p-dropdown>
              </ng-template>
              <ng-template pTemplate="output">{{currencyrates.CURCODE}}</ng-template>
            </p-cellEditor>
          </td>
          <td>{{currencyrates.CURNAME}}</td>
          <td style="overflow: visible !important">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-calendar inputId="basic" [dateFormat]="dateFormat" showTime="true" firstDayOfWeek="1"
                            selectOtherMonths="true" showIcon="true"
                            [(ngModel)]="currencyrates.CRDATE" (onSelect)="onDateSelect($event, currencyrates)" [style]="{'width':'100%'}"
                            (keydown)="$event.stopPropagation()"></p-calendar>
              </ng-template>
              <ng-template pTemplate="output">{{currencyrates.CRDATE | date: 'dd/MM/yyyy HH:mm'}}</ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="number" [(ngModel)]="currencyrates.CRVALUE"
                       [style]="{'width':'100%'}" step="0.0001" min="0" style="text-align: right" (keydown)="$event.stopPropagation()">
              </ng-template>
              <ng-template pTemplate="output">{{currencyrates.CRVALUE | number:'1.4-4'}}</ng-template>
            </p-cellEditor>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5">нет данных для загрузки</td>
        </tr>
      </ng-template>
    </p-table>
  </p-accordionTab>
</p-accordion>
